import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import "./portfolio.css";
import VisibleGrid from "../../containers/visible-grid";
import Title from "../title/title";

class Portfolio extends Component {
	render() {
		var titleContent = 'At Surfside Solutions, we take pride in producing business websites which are beautiful, dynamic and functional and which are also fully integrated with social media and search engines. Below you can see some of our latest web projects:'
		return (
			<div className="site-container" id="portfolio">
				<ReactCSSTransitionGroup
					transitionAppear={true}
					transitionAppearTimeout={600}
					transitionEnterTimeout={600}
					transitionLeaveTimeout={200}
					transitionName={'SlideUp'}
				>
					<Title name="portfolio" content={titleContent}/>
					<div className="site-inner">
						<VisibleGrid />
					</div>
				</ReactCSSTransitionGroup>
			</div>
		);
	}
}

export default Portfolio;


// WEBPACK FOOTER //
// ./src/components/portfolio/portfolio.js